import { useStripe } from '@stripe/react-stripe-js'

const ERROR_DECLINED = 'This payment was not able to be processed. Please verify the payment details and try again.'

export const useStripeConfirm = () => {
  const stripe = useStripe()

  const reviewStatus = ({ error, onSuccess, paymentIntent, setError }) => {
    if (error?.code === 'card_declined') return setError(ERROR_DECLINED)
    if (error) return setError(error.message)

    const { next_action: nextAction, status } = paymentIntent
    if (status === 'requires_payment_method')
      setError('Please attempt again with a different payment method.')
    else if (nextAction?.type === 'verify_with_microdeposits')
      setError('The account needs to be verified via microdeposits.')
    else if (['processing', 'succeeded'].includes(status))
      onSuccess(true)
  }

  const callConfirm = ({ clientSecret, isEnvTest, onSuccess, paymentMethodType, setError }) => {
    if (isEnvTest) return onSuccess(true)

    if (paymentMethodType === 'us_bank_account')
      stripe.confirmUsBankAccountPayment(clientSecret)
        .then(({ paymentIntent, error }) => {
          reviewStatus({ error, onSuccess, paymentIntent, setError })
        })
    else
      stripe.confirmCardPayment(clientSecret)
        .then(({ paymentIntent, error }) => {
          reviewStatus({ error, onSuccess, paymentIntent, setError })
        })
      }

  return [callConfirm]
}
